import { Languages } from "src/common/descriptions/types";
import { ExpenditureRecordsDescriptions } from "./types";

const DescriptionsEnUs: ExpenditureRecordsDescriptions = {
    TITLE: "Expenditure Records",
    TABLE: {
        ACTION_BUTTON: "Get Records",
        SEARCH_PLACEHOLDER: "Search Record",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Datetime",
        DESCRIPTION: "Description",
        CASH: "Cash",
        TRANSACTION: "Transaction",
        CASHBOX_CATEGORY: "Category",
        TOTAL: "Total",
        SERVICE_CATEGORY: "Service Category",
    },
    CREATE: "Create Record",
}

const DescriptionsEsUs: ExpenditureRecordsDescriptions = {
    TITLE: "Registro de Gastos",
    TABLE: {
        ACTION_BUTTON: "Ver Registros",
        SEARCH_PLACEHOLDER: "Buscar Registro",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Fecha",
        DESCRIPTION: "Descripción",
        CASH: "Efectivo",
        TRANSACTION: "Transacción",
        CASHBOX_CATEGORY: "Categoría",
        TOTAL: "Total",
        SERVICE_CATEGORY: "Servicio",
    },
    CREATE: "Crear Registro",
}

export const expenditureRecordsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}